import { render, staticRenderFns } from "./ConfirmAddress.vue?vue&type=template&id=572d05a1&scoped=true"
import script from "./ConfirmAddress.vue?vue&type=script&lang=js"
export * from "./ConfirmAddress.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAddress.vue?vue&type=style&index=0&id=572d05a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d05a1",
  null
  
)

export default component.exports